import store from '../store';

const langs = ['ru', 'en', 'uk', 'zh'],
    dictionaries = [
        'errors', 'settings', 'common', 'comments', 'committees', 'program', 'permissions', 'no-events',
        'exhibition', 'agenda', 'welcome', 'notifications', 'participants', 'meetings', 'web-conferences',
        'device-test', 'init-errors', 'favorites', 'event', 'tickets', 'chat', 'expert-ratings'
    ],
    temp: any = {};


dictionaries.forEach((item) => {
    langs.forEach((lang) => {
        try {
            const value = require('./' + lang + '/' + item + '.json');
            if (!temp[lang]) {
                temp[lang] = {};
            }
            temp[lang][item] = value;
        }
        catch (e) {
            store.dispatch('reportError', 'Locale dictionary not found: ' + lang + ' ' + item);
        }
    })
});

const messages = Object.freeze(temp);

export { messages }
